
	import {
		Vue,
		Component,
		Emit
	} from "vue-property-decorator";
	import empty from "../../components/empty.vue";
	import listRequest from '../../js/listRequest.js';
	import formHelper from '../../js/teachingMaterial/teaching.material.center.helper';
	@Component({
		components: {
			empty
		},
	})
	//export default class "组件名" extends Vue
	export default class teachingCenter extends Vue {
		query:any = {
		    subject: "",
		    period: "",
			teachingName:""
		};
		form: any = {
			id:"11111",
			name:"Python基础",
			introduction:"将Python编程与学科数学结合起来，将小学数学知识与代码编程相结合，促进学科之间的融合。一方面，提升学生的数学理解能力，另一方面提升学的编程能力、逻辑思维能力。另一方面提升学的编程能力、逻辑思维能力将Python编程与学科数学结合起来，将小学数学知识与代码编程相结合，促进学科之间的融合。一方面，提升学生的数学理解能力，另一方面提升学的编程能力、逻辑思维能力。另一方面提升学的编程能力、逻辑思维能力将Python编程与学科数学结合起来，将小学数学知识与代码编程相结合，促进学科之间的融合。一方面，提升学生的数学理解能力，另一方面提升学的编程能力、逻辑思维能力。另一方面提升学的编程能力、逻辑思维能力",
			relativeIamge:"", 
			subject:"通识课",
			period:"小学、初中、高中"
		};
		formRules: any = formHelper.formRules;
		showModel:boolean = true;
		mounted() {

		};

		created() {
		};
	}
